<form *ngIf="form" class="row g-3" [formGroup]="form">
  <div
    *ngFor="let group of json_form_data; index as groupIndex"
    [formArrayName]="'groups'"
    class="col col-12"
  >
    <div
      class="card"
      [tds-data-loader]="{ key: 'order-fields-' + group.name, size: 'lg', as_overlay: true }"
    >
      <div [formGroupName]="groupIndex" class="card-body">
        <h4 class="card-title pb-2">{{ group.display_name }}</h4>

        <div class="row d-flex g-3">
          <ng-container *ngFor="let field of sortFields(group.fields)" [formGroupName]="'fields'">
            <!-- Divider -->
            <span *ngIf="divider[group.name]?.includes(field.name)" class="col-12">
              <hr class="m-0" />
            </span>

            <ng-container [ngSwitch]="field.type">
              <!-- Text -->
              <ng-container *ngSwitchCase="['text', 'string'].includes(field.type) && field.type">
                <div
                  class="form-group {{ splitColumns(group, field) }}"
                  attr.aria-describedby="{{ field.id }}-help"
                >
                  <ng-container *ngTemplateOutlet="headerTemplate; context: { field: field }" />

                  <label
                    *ngIf="field.label"
                    class="form-label"
                    for="{{ field.name }}-{{ field.id }}"
                    [ngClass]="{ required: field.required }"
                  >
                    {{ field.label }}
                  </label>

                  <input
                    type="text"
                    id="{{ field.name }}-{{ field.id }}"
                    class="form-control"
                    restrict-input="{{ getTextDirective(field.name, group) }}"
                    [class.is-invalid]="field.control.errors && field.control.dirty"
                    [formControl]="field.control"
                    [required]="field.required"
                  />

                  <ng-container *ngTemplateOutlet="errorTemplate; context: { field: field }" />
                  <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                </div>
              </ng-container>

              <!-- Hidden -->
              <ng-container *ngSwitchCase="'hidden'">
                <div
                  class="form-group {{ splitColumns(group, field) }}"
                  attr.aria-describedby="{{ field.id }}-help"
                >
                  <ng-container *ngTemplateOutlet="headerTemplate; context: { field: field }" />

                  <label
                    *ngIf="field.label"
                    class="form-label"
                    for="{{ field.name }}-{{ field.id }}"
                    [ngClass]="{ required: field.required }"
                  >
                    {{ field.label }}
                  </label>

                  <input
                    type="text"
                    id="{{ field.name }}-{{ field.id }}"
                    class="form-control"
                    [class.is-invalid]="field.control.errors && field.control.dirty"
                    [formControl]="field.control"
                    [required]="field.required"
                  />

                  <ng-container *ngTemplateOutlet="errorTemplate; context: { field: field }" />
                  <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                </div>
              </ng-container>

              <!-- Password -->
              <ng-container *ngSwitchCase="'password'">
                <div
                  class="form-group {{ splitColumns(group, field) }}"
                  attr.aria-describedby="{{ field.id }}-help"
                >
                  <ng-container *ngTemplateOutlet="headerTemplate; context: { field: field }" />

                  <label
                    *ngIf="field.label"
                    for="{{ field.name }}-{{ field.id }}"
                    class="form-label"
                    [ngClass]="{ required: field.required }"
                  >
                    {{ field.label }}
                  </label>

                  <input
                    type="password"
                    id="{{ field.name }}-{{ field.id }}"
                    class="form-control fw-bold"
                    [class.is-invalid]="field.control.errors && field.control.dirty"
                    [formControl]="field.control"
                    [required]="field.required"
                    restrict-input="no_empty_space"
                  />

                  <ng-container *ngTemplateOutlet="errorTemplate; context: { field: field }" />
                  <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                </div>
              </ng-container>

              <!-- Expiry date -->
              <ng-container *ngSwitchCase="'expiry_date'">
                <div
                  class="form-group {{ splitColumns(group, field) }}"
                  attr.aria-describedby="{{ field.id }}-help"
                >
                  <ng-container *ngTemplateOutlet="headerTemplate; context: { field: field }" />

                  <label
                    *ngIf="field.label"
                    for="{{ field.name }}-{{ field.id }}"
                    class="form-label"
                    [ngClass]="{ required: field.required }"
                  >
                    {{ field.label }}
                  </label>

                  <input
                    id="{{ field.name }}-{{ field.id }}"
                    class="form-control"
                    [class.is-invalid]="field.control.errors && field.control.dirty"
                    type="text"
                    placeholder="MM/YY"
                    maxlength="5"
                    restrict-input="expiry_date"
                    [formControl]="field.control"
                    [required]="field.required"
                  />

                  <ng-container *ngTemplateOutlet="errorTemplate; context: { field: field }" />
                  <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                </div>
              </ng-container>

              <!-- Textarea -->
              <ng-container *ngSwitchCase="'textarea'">
                <div
                  class="form-group {{ splitColumns(group, field) }}"
                  attr.aria-describedby="{{ field.id }}-help"
                >
                  <ng-container *ngTemplateOutlet="headerTemplate; context: { field: field }" />

                  <label
                    *ngIf="field.label"
                    for="{{ field.name }}-{{ field.id }}"
                    class="form-label"
                    [ngClass]="{ required: field.required }"
                  >
                    {{ field.label }}
                  </label>

                  <textarea
                    class="form-control"
                    [class.is-invalid]="field.control.errors && field.control.dirty"
                    id="{{ field.name }}-{{ field.id }}"
                    [formControl]="field.control"
                    [required]="field.required"
                    restrict-input="no_empty_space"
                  ></textarea>

                  <ng-container *ngTemplateOutlet="errorTemplate; context: { field: field }" />
                  <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                </div>
              </ng-container>

              <!-- Select -->
              <ng-container *ngSwitchCase="'select'">
                <div
                  *ngIf="showSelectField(field.name, group)"
                  class="form-group {{ splitColumns(group, field) }}"
                  attr.aria-describedby="{{ field.id }}-help"
                >
                  <ng-container *ngTemplateOutlet="headerTemplate; context: { field: field }" />

                  <label
                    *ngIf="field.label"
                    for="{{ field.name }}-{{ field.id }}"
                    class="form-label"
                    [ngClass]="{ required: field.required }"
                  >
                    {{ field.label }}
                  </label>

                  <select
                    id="{{ field.name }}-{{ field.id }}"
                    class="form-select"
                    [class.is-invalid]="field.control.errors && field.control.dirty"
                    [formControl]="field.control"
                  >
                    <option *ngIf="!hideSelectOneOption(field.name, group)" value="">
                      {{ 'select_one' | translate }}
                    </option>
                    <option *ngFor="let option of field.options" value="{{ option.value }}">
                      {{ option.label }}
                    </option>
                  </select>

                  <ng-container *ngTemplateOutlet="errorTemplate; context: { field: field }" />
                  <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                </div>
              </ng-container>

              <!-- Grouped Select -->
              <ng-container *ngSwitchCase="'grouped_select'">
                <div
                  class="form-group {{ splitColumns(group, field) }}"
                  attr.aria-describedby="{{ field.id }}-help"
                >
                  <ng-container *ngTemplateOutlet="headerTemplate; context: { field: field }" />

                  <label
                    *ngIf="field.label"
                    for="{{ field.name }}-{{ field.id }}"
                    class="form-label"
                    [ngClass]="{ required: field.required }"
                  >
                    {{ field.label }}
                  </label>

                  <select
                    id="{{ field.name }}-{{ field.id }}"
                    class="form-select"
                    [class.is-invalid]="field.control.errors && field.control.dirty"
                    [formControl]="field.control"
                  >
                    <option *ngIf="!hideSelectOneOption(field.name, group)" value="">
                      {{ 'select_one' | translate }}
                    </option>
                    <optgroup *ngFor="let group of field.grouped_options" [label]="group.label">
                      <option *ngFor="let item of group.options" [value]="item.value">
                        {{ item.label }}
                      </option>
                    </optgroup>
                  </select>

                  <ng-container *ngTemplateOutlet="errorTemplate; context: { field: field }" />
                  <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                </div>
              </ng-container>

              <!-- Radio -->
              <ng-container *ngSwitchCase="'radio'">
                <div
                  class="form-group {{ splitColumns(group, field) }}"
                  attr.aria-describedby="{{ field.id }}-help"
                >
                  <ng-container *ngTemplateOutlet="headerTemplate; context: { field: field }" />

                  <fieldset>
                    <label class="form-label" [ngClass]="{ required: field.required }">
                      {{ field.label }}
                    </label>
                    <div *ngFor="let option of field.options; index as i" class="form-check">
                      <input
                        id="{{ group.name }}-{{ field.id }}-{{ i }}"
                        class="form-check-input"
                        [class.is-invalid]="field.control.errors && field.control.dirty"
                        type="radio"
                        [value]="option.value"
                        [name]="field.name"
                        [formControl]="field.control"
                      />

                      <label class="form-check-label" for="{{ group.name }}-{{ field.id }}-{{ i }}">
                        {{ option.label }}
                      </label>
                    </div>
                  </fieldset>

                  <ng-container *ngTemplateOutlet="errorTemplate; context: { field: field }" />
                  <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                </div>
              </ng-container>

              <!-- Date -->
              <ng-container *ngSwitchCase="'date'">
                <ts-date-picker
                  class="{{ splitColumns(group, field) }}"
                  id="{{ field.name }}-{{ field.id }}"
                  [label]="field.label"
                  [name]="field.name"
                  [help_text]="field.help_text"
                  [required]="field.required"
                  [control]="field.control"
                  [header_text]="field.header_text"
                  [validate_pattern]="field.value !== field.control.value"
                />
              </ng-container>

              <!-- File input -->
              <ng-container *ngSwitchCase="'file'">
                <div
                  class="form-group {{ splitColumns(group, field) }}"
                  attr.aria-describedby="{{ field.id }}-help"
                >
                  <ng-container *ngTemplateOutlet="headerTemplate; context: { field: field }" />

                  <label
                    *ngIf="field.label"
                    for="file-input-{{ field.id }}"
                    class="form-label"
                    [ngClass]="{ required: field.required }"
                  >
                    {{ field.label }}
                  </label>

                  <input
                    *ngIf="!field.value"
                    id="file-input-{{ field.id }}"
                    class="form-control"
                    [class.is-invalid]="field.control.errors && field.control.dirty"
                    type="file"
                    [required]="field.required"
                    (change)="onFileChange($event, field, field.control)"
                  />

                  <div *ngIf="field.value" id="file-value-{{ field.id }}">
                    <span class="d-flex align-items-center">
                      {{ field.value }} &nbsp;
                      <span
                        class="material-icons fs-6 cursor-pointer"
                        aria-hidden="true"
                        (click)="deleteFile(field)"
                      >
                        close
                      </span>
                    </span>
                  </div>

                  <ng-container *ngTemplateOutlet="errorTemplate; context: { field: field }" />
                  <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                </div>
              </ng-container>

              <!-- Checkbox -->
              <ng-container *ngSwitchCase="'checkbox'">
                <div
                  class="form-group {{ splitColumns(group, field) }}"
                  attr.aria-describedby="{{ field.id }}-help"
                >
                  <ng-container *ngTemplateOutlet="headerTemplate; context: { field: field }" />

                  <div class="form-check">
                    <input
                      id="{{ field.name }}-{{ field.id }}"
                      class="form-check-input"
                      [class.is-invalid]="field.control.errors && field.control.dirty"
                      type="checkbox"
                      [name]="field.name"
                      [formControl]="field.control"
                      [required]="field.required"
                    />

                    <label
                      for="{{ field.name }}-{{ field.id }}"
                      class="form-check-label"
                      [ngClass]="{ required: field.required }"
                    >
                      {{ field.label }}
                    </label>
                  </div>

                  <ng-container *ngTemplateOutlet="errorTemplate; context: { field: field }" />
                  <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                </div>
              </ng-container>

              <!-- Boolean -->
              <ng-container *ngSwitchCase="'boolean'">
                <div
                  class="form-group {{ splitColumns(group, field) }}"
                  attr.aria-describedby="{{ field.id }}-help"
                >
                  <ng-container *ngTemplateOutlet="headerTemplate; context: { field: field }" />

                  <div class="form-check form-switch">
                    <input
                      id="{{ field.name }}-{{ field.id }}"
                      class="form-check-input"
                      [class.is-invalid]="field.control.errors && field.control.dirty"
                      type="checkbox"
                      role="switch"
                      [name]="field.name"
                      [formControl]="field.control"
                    />

                    <label
                      for="{{ field.name }}-{{ field.id }}"
                      class="form-check-label"
                      [ngClass]="{ required: field.required }"
                    >
                      {{ field.label }}
                    </label>
                  </div>

                  <ng-container *ngTemplateOutlet="errorTemplate; context: { field: field }" />
                  <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                </div>
              </ng-container>

              <!-- Readonly -->
              <ng-container *ngSwitchCase="'readonly'">
                <ng-container [ngSwitch]="field.name">
                  <ng-container *ngSwitchCase="'country_id'">
                    <ng-container
                      *ngTemplateOutlet="addressTemplate; context: { group: group, field: field }"
                    />
                  </ng-container>

                  <ng-container *ngSwitchCase="'agreement'">
                    <ng-container
                      *ngTemplateOutlet="agreementTemplate; context: { group: group, field: field }"
                    />
                  </ng-container>

                  <ng-container *ngSwitchCase="'credit_card.card_number'">
                    <ng-container
                      *ngTemplateOutlet="
                        paymentDetailTemplate;
                        context: { group: group, field: field }
                      "
                    />
                  </ng-container>

                  <ng-container *ngSwitchCase="'credit_card.billing_address'">
                    <ng-container
                      *ngTemplateOutlet="
                        creditCardAddressTemplate;
                        context: { group: group, field: field }
                      "
                    />
                  </ng-container>

                  <ng-container *ngSwitchCase="'same_as_shipping_address_field'">
                    <div>
                      <ng-container
                        *ngTemplateOutlet="billingAddressTemplate; context: { field: field }"
                      />
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'current_carrier_account'">
                    <span *ngIf="hasNewCarrierAccounts(group); else noNewCarrierAccounts">
                      <ng-container
                        *ngTemplateOutlet="
                          currentCarrierAccountTemplate;
                          context: { group: group, field: field }
                        "
                      />
                    </span>

                    <ng-template #noNewCarrierAccounts>
                      <div class="col-12 form-group">
                        <span class="d-flex col alert alert-warning mb-0" role="alert">
                          {{ 'no_additional_carrier_accounts' | translate }}
                        </span>
                      </div>
                    </ng-template>
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    <div
                      *ngIf="readOnlyTemplate(field, group)"
                      [innerHTML]="readOnlyTemplate(field, group) | domSanitizer"
                      [ngClass]="[splitColumns(group, field), 'normalize-external-styles']"
                    ></div>
                  </ng-container>
                </ng-container>
              </ng-container>

              <!-- Device select -->
              <ng-container *ngSwitchCase="'device_select'">
                <ts-device-select
                  class="{{ splitColumns(group, field) }}"
                  id="{{ field.id }}"
                  [label]="field.label"
                  [name]="field.name"
                  [help_text]="field.help_text"
                  [required]="field.required"
                  [control]="field.control"
                  [header_text]="field.header_text"
                />
              </ng-container>

              <!-- Line select -->
              <ng-container *ngSwitchCase="'line_select'">
                <ts-line-select
                  class="{{ splitColumns(group, field) }}"
                  id="{{ field.id }}"
                  [label]="field.label"
                  [name]="field.name"
                  [help_text]="field.help_text"
                  [required]="field.required"
                  [control]="field.control"
                  [header_text]="field.header_text"
                />
              </ng-container>

              <!-- Person select -->
              <ng-container *ngSwitchCase="'person_select'">
                <ts-person-select
                  class="{{ splitColumns(group, field) }}"
                  id="{{ field.id }}"
                  [label]="field.label"
                  [name]="field.name"
                  [help_text]="field.help_text"
                  [required]="field.required"
                  [control]="field.control"
                  [header_text]="field.header_text"
                />
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</form>

<ng-template #addressTemplate let-group="group" let-field="field">
  <div [class]="splitColumns(group, field)">
    <div
      *ngIf="getAddressLabel(group)"
      class="form-label pt-2 normalize-external-styles"
      [innerHTML]="getAddressLabel(group) | domSanitizer"
    ></div>

    <div>
      <span>
        {{ getFieldValue('company_name', group) }}
      </span>
    </div>
    <div>
      <span>{{ getFieldValue('address1', group) }}</span>
    </div>
    <div>
      <span>{{ getFieldValue('address2', group) }}</span>
    </div>
    <div>
      <span>{{ getFieldValue('city', group) }}, {{ getFieldValue('state', group) }}</span>
      <span>{{ getFieldValue('zip', group) }}</span>
    </div>
    <div>{{ field.display_name }}</div>
  </div>
</ng-template>

<ng-template #creditCardAddressTemplate let-group="group" let-field="field">
  <span class="col-12">
    <hr class="m-0" />
  </span>

  <div [class]="splitColumns(group, field)">
    <h5 class="form-label py-2">{{ 'billing_address' | translate }}</h5>
    <ng-container *ngTemplateOutlet="billingAddressTemplate; context: { field: field }" />
  </div>
</ng-template>

<ng-template #billingAddressTemplate let-field="field">
  <div>
    <span>{{ field.value.company_name }}</span>
  </div>
  <div>
    <span>{{ field.value.address1 }}</span>
  </div>
  <div>
    <span>{{ field.value.address2 }}</span>
  </div>
  <div>
    <span>{{ field.value.city }}, {{ field.value.state }}</span>
    <span>{{ field.value.zip }}</span>
  </div>
  <div>
    <span>{{ field.value.country }}</span>
  </div>
</ng-template>

<ng-template #currentCarrierAccountTemplate let-group="group" let-field="field">
  <div>
    <label
      class="form-label"
      for="{{ field.name }}-{{ field.id }}"
      [ngClass]="{ required: field.required }"
    >
      {{ field.label }}
    </label>

    <select
      id="{{ field.name }}-{{ field.id }}"
      class="form-select"
      [class.is-invalid]="field.control.errors && field.control.dirty"
      [formControl]="field.control"
    >
      <option
        *ngIf="
          getFieldValue('current_carrier_account', group) !== '';
          else noCurrentCarrierOptionValue
        "
        [value]="getFieldValue('current_carrier_account', group)"
      >
        {{ getFieldValue('current_carrier_account', group) }}
      </option>
      <ng-template #noCurrentCarrierOptionValue>
        <option>
          {{ 'n_a' | translate }}
        </option>
      </ng-template>
    </select>
  </div>
</ng-template>

<ng-template #agreementTemplate let-group="group" let-field="field">
  <div [class]="splitColumns(group, field)">
    <div
      id="{{ field.name }}-{{ field.id }}"
      class="resizable-element normalize-external-styles"
      [ngClass]="{ scrollable: field.value!.toString().length > 1500 }"
      [innerHTML]="field.value!.toString() | domSanitizer"
    ></div>

    <div
      class="d-inline-flex align-items-center cursor-pointer pt-2"
      (click)="printAgreement(group, field.value)"
    >
      <span class="material-icons pe-1 print-icon" aria-hidden="true">print</span>
      <a href="javascript:void(0)">
        {{ 'print_this_document' | translate }}
      </a>
    </div>
  </div>
</ng-template>

<ng-template #paymentDetailTemplate let-group="group" let-field="field">
  <div [class]="splitColumns(group, field)">
    <div class="d-flex align-items-center">
      <img
        *ngIf="getFieldValue('credit_card.card_type', group)"
        class="img-fluid pe-2 payment-card-img"
        src="{{ getPaymentCardImage(getFieldValue('credit_card.card_type', group)) }}"
        alt="payment card"
      />
      <span>{{ getFieldValue('credit_card.card_number', group) }}</span>
    </div>
    <div>
      <span>{{ getFieldValue('credit_card.name_on_card', group) }}</span>
    </div>
    <div>
      <span>{{ getFieldValue('credit_card.expires', group) }}</span>
    </div>
  </div>
</ng-template>

<ng-template #headerTemplate let-field="field">
  <div
    *ngIf="field.header_text"
    class="header-text normalize-external-styles"
    [innerHTML]="field.header_text | domSanitizer"
  ></div>
</ng-template>

<ng-template #errorTemplate let-field="field">
  <div
    *ngIf="field.control.dirty && field.control.errors"
    id="{{ field.id }}-error"
    class="text-danger mt-2"
  >
    <span *ngIf="field.control.errors['required']">
      {{ 'input_is_required' | translate: field.label }}
    </span>
    <span *ngIf="field.control.errors['_error']">
      <ul class="m-0 p-0 list-unstyled">
        <li *ngFor="let error of field.control.errors['_error']" class="fw-light">{{ error }}</li>
      </ul>
    </span>
  </div>
</ng-template>

<ng-template #helpTemplate let-field="field">
  <div *ngIf="field.help_text" id="{{ field.id }}-help" class="form-text">
    {{ field.help_text }}
  </div>
</ng-template>
